// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('estimatePref/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('estimatePref/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/Prefrences/GetSalesEstimatePrefrences', { params })
    const responseColumns = await axios.get('/Prefrences/GetSalesEstimateFormColumns', {})

    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
        columns: responseColumns.data
    }
})

export const getCodeCustomization = createAsyncThunk('estimatePref/getCodeCustomization', async (params, { dispatch }) => {
    dispatch(setLoading({ getCodeCustomization: true }))
    const response = await axios.get('/Prefrences/GetDocumentCodesPrefrences', { params })

    dispatch(setLoading({ getCodeCustomization: false }))
    return {
        params,
        data: response.data
    }
})

export const estimatePref = createSlice({
    name: 'estimatePref',
    initialState: {
        data: [],
        columns: [],
        terms: "",
        notes: "",
        copyNotesToInvoice: false,
        copyTermsToInvoice: false,
        codeCustomization: {},
        totalRecords: 1,
        params: {},
        loadingState: { getData: false, getCodeCustomization: false }
        // allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data.list
                state.columns = (action.payload.columns.data??[]).sort((a, b) => a.columnSeq - b.columnSeq)
                state.terms = action.payload.data.data.terms
                state.notes = action.payload.data.data.notes
                state.copyNotesToInvoice = action.payload.data.data.copyNotesToInvoice
                state.copyTermsToInvoice = action.payload.data.data.copyTermsToInvoice
                state.totalRecords = action.payload.data.totalRecords
                state.params = action.payload.params
            })
            .addCase(getCodeCustomization.fulfilled, (state, action) => {
                state.codeCustomization = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default estimatePref.reducer
